import React from 'react'
import ChangeOfLocationDtls from './ChangeOfLocationDtls'

export default function ChangeOfLocation(paymentDone, goNext) {
    return (
        <div>
            <ChangeOfLocationDtls paymentDone={paymentDone} goNext={goNext} />
        </div>
    )
}
